import { render, staticRenderFns } from "./modalCrearFeature.vue?vue&type=template&id=67911eb6&"
import script from "./modalCrearFeature.vue?vue&type=script&lang=js&"
export * from "./modalCrearFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports